import React, { useMemo } from 'react';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDateTimeToShowUser } from 'features/common/helpers';
import { ITransactionFinalization } from 'features/transaction-details/types';
import { formatTransactionAmount } from 'features/transaction-details/helpers';
import { sortFinalizationsChronologically } from 'features/transaction-details/helpers/finalizationCopy';

interface TransactionFinalizationsDetailProps {
	finalizations: ITransactionFinalization[];
	coinCode: string;
}

export const TransactionFinalizationsDetail = ({
	finalizations,
	coinCode,
}: TransactionFinalizationsDetailProps): JSX.Element | null => {
	const sorted = useMemo(() => sortFinalizationsChronologically(finalizations), [finalizations]);

	if (sorted.length === 0) return null;

	const fmt = (amount: number): string => formatTransactionAmount(amount, coinCode);

	return (
		<Accordion variant="outlined" disableGutters sx={{ mt: 4, borderRadius: 2, '&:before': { display: 'none' } }}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Typography variant="subtitle1" fontWeight="bold">
					Detalle técnico de finalizaciones ({sorted.length})
				</Typography>
			</AccordionSummary>
			<AccordionDetails sx={{ pt: 0 }}>
				<TableContainer component={Paper} variant="outlined">
					<Table size="small">
						<TableHead>
							<TableRow>
								<TableCell>Monto antes</TableCell>
								<TableCell>Autorizado al finalizar</TableCell>
								<TableCell>Pend. autorizar antes</TableCell>
								<TableCell>Pend. cruzar antes</TableCell>
								<TableCell>Fecha</TableCell>
								<TableCell>Usuario</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{sorted.map((finalization) => (
								<TableRow key={finalization.id}>
									<TableCell>{fmt(finalization.amountBeforeFinalize)}</TableCell>
									<TableCell>{fmt(finalization.amountAuthorizedAtFinalize)}</TableCell>
									<TableCell>{fmt(finalization.pendingAuthorizationBeforeFinalize)}</TableCell>
									<TableCell>{fmt(finalization.pendingToCrossBeforeFinalize)}</TableCell>
									<TableCell>{formatDateTimeToShowUser(finalization.createdAt)}</TableCell>
									<TableCell>{finalization.createdBy}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</AccordionDetails>
		</Accordion>
	);
};
